import React from "react";
import {
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  Youtube,
  Music as TikTokIcon,
} from "lucide-react";
import { Platform } from "../types";

// Brand SVG icons for better visual consistency
const BrandIcons = {
  linkedin: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.223 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.452c.98 0 1.777-.773 1.777-1.729V1.729C24 .774 23.203 0 22.223 0zM7.12 20.452H3.558V8.995H7.12v11.457zM5.34 7.433a2.064 2.064 0 110-4.128 2.064 2.064 0 010 4.128zM20.452 20.452h-3.558v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667h-3.558V8.995h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.291z" fill="#0A66C2"/>
    </svg>
  ),
  facebook: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.969h-1.514c-1.491 0-1.956.932-1.956 1.886v2.268h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" fill="#1877F2"/>
      <path d="M16.671 15.563l.532-3.49h-3.328V9.805c0-.954.465-1.886 1.956-1.886h1.514V4.95s-1.374-.235-2.686-.235c-2.741 0-4.533 1.672-4.533 4.697v2.66H7.078v3.49h3.047V24a12.13 12.13 0 003.75 0v-8.437h2.796z" fill="white"/>
    </svg>
  ),
  instagram: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="ig-grad-full" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.438 21.75) rotate(-43.256) scale(29.136 29.136)">
          <stop stopColor="#FED011"/>
          <stop offset=".141" stopColor="#F7B220"/>
          <stop offset=".357" stopColor="#E56D42"/>
          <stop offset=".566" stopColor="#D22A6E"/>
          <stop offset=".77" stopColor="#A60E9B"/>
          <stop offset="1" stopColor="#515BD4"/>
        </radialGradient>
      </defs>
      <path d="M12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.667.072 4.947c.2 4.354 2.616 6.777 6.98 6.977C8.333 23.986 8.741 24 12 24s3.667-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.667.014 15.259 0 12 0zm0 2.16c3.203 0 3.584.016 4.85.071 3.27.144 4.775 1.657 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.261-1.655 4.779-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.583-.012-4.849-.07c-3.26-.14-4.77-1.652-4.919-4.92-.058-1.265-.07-1.644-.07-4.848 0-3.204.012-3.584.07-4.849.149-3.265 1.656-4.779 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm7.846-10.405a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" fill="url(#ig-grad-full)"/>
    </svg>
  ),
  twitter: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  youtube: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z" fill="#FF0000"/>
      <path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white"/>
    </svg>
  ),
  tiktok: (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} fill="currentColor" viewBox="0 0 24 24">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </svg>
  ),

};
// Function to get brand icon component or fallback to lucide icon
export const getPlatformIcon = (platform: Platform) => {
  return (
    BrandIcons[platform] ||
    {
      facebook: Facebook,
      instagram: Instagram,
      twitter: Twitter,
      linkedin: Linkedin,
      tiktok: TikTokIcon,
      youtube: Youtube,
    }[platform]
  );
};

// Get platform colors for text, borders, etc.
export const getPlatformColors = (platform: Platform) => {
  const colors = {
    facebook: "bg-[#1666fb] border-blue-200 text-[blue-600]",
    instagram:
      "bg-gradient-to-r from-purple-500 to-pink-500 border-purple-200 text-purple-600",
    twitter: "bg-black border-gray-300 text-black",
    linkedin: "bg-[#1266bf] border-blue-200 text-blue-700",
    tiktok: "bg-black border-gray-300 text-black",
    youtube: "bg-red-600 border-red-200 text-red-600",
  };
  return (
    colors[platform] || "bg-gray-600 border-gray-200 text-gray-500 font-medium"
  );
};

// Get platform background colors for icon containers
export const getPlatformIconBackgroundColors = (platform: Platform) => {
  const colors = {
    facebook: "bg-[#1666fb]",
    instagram: "bg-gradient-to-r from-purple-500 to-pink-500",
    twitter: "bg-black",
    linkedin: "bg-[#1266bf]",
    tiktok: "bg-black",
    youtube: "bg-red-600",
  };
  return colors[platform] || "bg-gray-600";
};

export const getPlatformBackgroundColors = (platform: Platform) => {
  const colors = {
    facebook: "bg-blue-50 border-blue-200",
    instagram: "bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200",
    twitter: "bg-gray-50 border-gray-200",
    linkedin: "bg-blue-50 border-blue-200",
    tiktok: "bg-gray-50 border-gray-200",
    youtube: "bg-red-50 border-red-200",
  };
  return colors[platform] || "bg-gray-50 border-gray-200";
};

export const getPlatformDisplayName = (platform: Platform) => {
  const names = {
    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    tiktok: "TikTok",
    youtube: "YouTube",
  };
  return names[platform] || platform;
};

export const platformOptions = [
  {
    id: "facebook" as Platform,
    name: "Facebook",
    icon: Facebook,
    color: "text-blue-600",
    bgColor: "bg-white",
    borderColor: "border-blue-200",
  },
  {
    id: "instagram" as Platform,
    name: "Instagram",
    icon: Instagram,
    color: "text-purple-600",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
  },
  // {
  //   id: "twitter" as Platform,
  //   name: "Twitter",
  //   icon: Twitter,
  //   color: "text-black",
  //   bgColor: "bg-gray-50",
  //   borderColor: "border-gray-200",
  // },
  {
    id: "linkedin" as Platform,
    name: "LinkedIn",
    icon: Linkedin,
    color: "text-blue-700",
    bgColor: "bg-white",
    borderColor: "border-blue-200",
  },
  {
    id: "tiktok" as Platform,
    name: "TikTok",
    icon: TikTokIcon,
    color: "text-black",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-200",
  },
  {
    id: "youtube" as Platform,
    name: "YouTube",
    icon: Youtube,
    color: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
  },
];
